const childRoutes = (prop) => [
    {
        path: 'exam-schedule',
        name: prop + '.exam_schedule',
        meta: { auth: true },
        component: () => import('../pages/exam-schedule/List.vue')
    },
    {
        path: 'curriculum-wise-progress',
        name: prop + '.curriculum_wise_progress',
        meta: { auth: true },
        component: () => import('../pages/curriculum-progress-setting/List.vue')
    },
    {
        path: 'curriculum-wise-progress-setting',
        name: prop + '.curriculum_wise_progress_setting',
        meta: { auth: true },
        props: true,
        component: () => import('../pages/curriculum-progress-setting/Form.vue')
    },
    {
        path: 'subject-wise-result-setting',
        name: prop + '.subject_wise_result_setting',
        meta: { auth: true },
        component: () => import('../pages/subject-wise-result-setting/List.vue')
    },
    {
        path: 'subject-wise-result-entry',
        name: prop + '.subject_wise_result_entry',
        meta: { auth: true },
        props: true,
        component: () => import('../pages/subject-wise-result-setting/Form.vue')
    },
    {
        path: 'progress-letter',
        name: prop + '.progress_letter',
        meta: { auth: true },
        component: () => import('../pages/progress-letter/List.vue')
    },
    {
        path: 'home-work-evolution',
        name: prop + '.home_work_evolution',
        meta: { auth: true },
        component: () => import('../pages/home-work-evalution/List.vue')
    },
    {
        path: 'home-work-evolution-entry',
        name: prop + '.home_work_evolution_entry',
        meta: { auth: true },
        props: true,
        component: () => import('../pages/home-work-evalution/Form.vue')
    },
    {
        path: 'result-approval',
        name: prop + '.result_approval',
        meta: { auth: true },
        component: () => import('../pages/result-approval/List.vue')
    },
    {
        path: 'published-result',
        name: prop + '.published_result',
        meta: { auth: true },
        component: () => import('../pages/published-result/List.vue')
    }
]
const routes = [{
    path: '/disability-school-service/exam-and-result-management',
    name: 'disability_school_service.exam_and_result_management',
    component: () => import('@/layouts/DisabilitySchoolLayout.vue'),
    meta: { auth: true },
    children: childRoutes('disability_school_service.exam_and_result_management')
}]
export default routes
